export default __webpack_public_path__ + "static/media/msme.edff84fa.webp";